import { Avatar, Box, Grid, Typography, useMediaQuery } from "@mui/material";

import { showcase } from "@/utils/staticData/showcase";
import sparkles_iconUrl from "@/assets/icons/about-us/sparkles.svg";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import {
  avatarStyles,
  getImageWrapperStyles,
  getWrapperStyles,
  messageStyles,
} from "./styles";

const FleetManagementShowcase = () => {
  const isLargeDesktop = useMediaQuery("(min-width: 1700px)");
  const isMaxContainer = useMediaQuery("(min-width: 1568px)");

  return (
    <Box
      boxSizing="border-box"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      pt={{ xs: 4, md: 7, lg: 10 }}
      pb={{ xs: 4, md: 7, lg: 11.5 }}
      pl={{ md: 7, xl: 10 }}
      pr={{ md: 7, xl: 7 }}
      sx={{ overflowX: "hidden" }}
      bgcolor="background.default"
      borderRadius={{ xs: 3.5, md: 5 }}
      width={{
        md: "114%",
        xl: isMaxContainer ? "47vw" : "114%",
      }}
      maxWidth={958}
    >
      <Typography
        variant="h6"
        gap={1}
        sx={messageStyles}
        pl={{ md: 1.5, lg: 2.5 }}
        mb={{ xs: 1.5, md: 3.5 }}
      >
        <Avatar src={sparkles_iconUrl} sx={avatarStyles} />
        We’ll gladly send you free trackers!
      </Typography>

      <Box
        sx={{
          transform: {
            md: "translateX(-4px)",
            xl: isLargeDesktop ? "translateX(-14px)" : "translateX(-4px)",
          },
          width: "108%",
        }}
      >
        <Grid container spacing={{ xs: 1 }} width="100%">
          {showcase.map(({ name, image, thumbnail }, index) => (
            <Grid item md={index === 0 ? 3.25 : 4.375} key={index}>
              <Box
                height="100%"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={getWrapperStyles(index, isMaxContainer)}
              >
                <AnimatedImage
                  sx={getImageWrapperStyles(index)}
                  thumbnailUrl={thumbnail}
                  mainUrl={image}
                  alt={name}
                />

                <Typography
                  variant="caption"
                  component="p"
                  color="text.primary"
                  fontWeight={700}
                  fontSize={{ xs: 14, md: 16 }}
                  width={index === 2 ? "60%" : "100%"}
                  textAlign="center"
                >
                  {name}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FleetManagementShowcase;
